import { ReactNode } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from '@mui/styles';

type placementType =
  | 'bottom'
  | 'left'
  | 'right'
  | 'top'
  | 'bottom-end'
  | 'bottom-start'
  | 'left-end'
  | 'left-start'
  | 'right-end'
  | 'right-start'
  | 'top-end'
  | 'top-start';

interface Props {
  children: ReactNode;
  title: string;
  className?: string;
  placement?: placementType;
  arrow?: boolean;
}

const style = makeStyles(() => ({
  tooltip: {
    padding: '8px',
    maxWidth: '330px',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: '400',
    textAlign: 'justify',
    direction: 'rtl',
    lineHeight: '19px',
  },
}));

const _Tooltip = ({ children, title, className, placement }: Props) => {
  const classes = style();
  return (
    <Tooltip
      disableTouchListener
      disableFocusListener
      classes={classes}
      className={className}
      arrow
      placement={placement}
      title={title}
    >
      <div>{children}</div>
    </Tooltip>
  );
};

_Tooltip.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  placement: PropTypes.string,
};

_Tooltip.defaultProps = {
  className: '',
  placement: 'top',
};

export default _Tooltip;
